import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center p-10 bg-white border-b border-gray-200 flex py-4 md:pl-4 justify-between" }
const _hoisted_2 = { class: "flex lg:flex-row flex-col" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:mr-auto" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { class: "flex gap-5 md:mr-auto items-center" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "text-sm px-1" }
const _hoisted_8 = { class: "text-sm px-1" }
const _hoisted_9 = { class: "py-6" }
const _hoisted_10 = { class: "flex justify-end mr-7" }

import DataTable from "@/components/tools/DataTable.vue";
import Navbar from "@/components/tools/Navbar.vue";
import { AxiosInstance } from "axios";
import { inject, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import MultipleDepositTierConfig from "@/components/dialogs/MultipleDepositTierConfig.vue";
import { translate } from "@/utils/tools";
import {Switch} from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMultipleDepositConfig',
  setup(__props) {

const store = useStore();
const axios = inject("$axios") as AxiosInstance;

const rowsData = ref<any[]>([]);
let useDepositTrue = ref<any[]>([]);
let useDepositFalse = ref<any[]>([]);
const showCreateMultipleDepositDialog = ref(false);
const disableDeposit = ref<boolean>(true)

const isLoaded = ref(false);
const addPayment= async (payment:any) => {
      isLoaded.value = false;
    try{
      console.log(payment)
      const paymentCount = rowsData.value.length
      if(paymentCount>=3) {
        alert("Deposit payment amount limit!!")
        isLoaded.value = true;
        return;
      }
      const findDup = rowsData.value.find((p) => p.id===payment.id)
      if(findDup){
        alert("Duplicate Deposit Payment!!")
        isLoaded.value = true;
        return;
      }
      rowsData.value.push({
        id:payment.id,
        priority:paymentCount + 1,
        useDeposit:true,
        paymentName:payment.name
      })
      } catch (e: any) {
        console.log(e)
        alert('Add Failed')
      }

  isLoaded.value = true;
};
const updatePayment = async () => {
  isLoaded.value = false;
  try {
    await axios
    .post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-config/setup/multiple-deposit/${store.state.selectedOperator.operatorId}`,
      {operatorMultipleDeposit:rowsData.value},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(({ data }) => {
     alert('Update Success')
    })
  } catch (e: any) {
    console.log(e)
  }

  isLoaded.value = true;
};

const onToggleDeposit = async () => {
  if (confirm("Are you sure?")) {
    await toggleDisableDeposit()
  } else {
    return
  }
}

const toggleDisableDeposit = async () => {

    try {
      let payload = {
        operatorId: store.state.selectedOperator.operatorId,
        allowWithdraw: undefined,
        allowDeposit: !disableDeposit.value
      }
      const { data } = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator/operator/update/payment-allow`,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
      )
      console.log(data)
      if (!data) {
        throw new Error('err')
      }
      console.log("two", disableDeposit.value)

      await getAllowPayment()
    } catch (error) {
      alert("update failed")
    }
}

const fetchPayment = async () => {
  isLoaded.value = false;
  let payload = {
    operatorId: store.state.selectedOperator.operatorId,
  }
  await axios
    .post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-gateway/operator`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(({ data }) => {
      useDepositTrue.value = data.filter((item: { useDeposit: boolean; }) => item.useDeposit).map((item: any) => ({
        id:item.id,
        paymentName:item.paymentName,
        priority: item.priority ? item.priority : 1
      }));

      useDepositFalse.value = data.filter((item: { useDeposit: boolean; }) => !item.useDeposit).map((item: any) => ({
        id:item.id,
        paymentName:item.paymentName,
        priority: item.priority
      }));
      rowsData.value = useDepositTrue.value
    })
  isLoaded.value = true;
};

const getAllowPayment = async () => {
  const result = await axios
  .post<{ operatorId: string, allowWithdraw: boolean, allowDeposit: boolean }>(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator/operator/read/payment-allow`,
      {operatorId: store.state.selectedOperator.operatorId},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
  )
  .then(({ data }) => data)
  disableDeposit.value = result.result[0].allowDeposit
}

const columns = ref([
  {
    label: translate("messages.multipleDepositConfig.priority"),
    field: "priority",
    format: (data: any) =>
      data.priority,
    styles: { td: { width: '20\px' } },
  },
{
    label: translate("messages.multipleDepositConfig.paymentName"),
    field: "paymentName",
    format: (data: any) =>
      data.paymentName,
  },
  {
    label: '',
    field: "",
    isFunction: true,
    function: async (data: any) => {
      if (data.priority == 1 ){
        return alert('Failed')
      }
      rowsData.value.map((item: { paymentName: string, priority: number }, index, arr: any) => {
        if (item.paymentName === data.paymentName) {
          item.priority = item.priority - 1;
          if (arr[index - 1]) {
            arr[index - 1].priority = arr[index - 1].priority + 1;
          }
        }
        return item;
      });

      rowsData.value.sort((a: any, b: any) => a.priority - b.priority);
    },
    format: (data:any) => {
      if(data.priority == 1){
        return ''
      }
      return '↑'
    },
    class: () => "cursor-pointer",
    styles: { td: { width: '20\px' } },
  },
  {
    label: '',
    field: "",
    isFunction: true,
    function: async (data: any) => {
      if (data.priority == rowsData.value.length ){
        return alert('Failed')
      }
      rowsData.value.map((item: { paymentName: string, priority: number }, index, arr: any) => {
        if (item.paymentName === data.paymentName) {
          item.priority = item.priority + 1;
          if (arr[index + 1]) {
            arr[index + 1].priority = arr[index + 1].priority - 1;
          }
        }
        return item
      });

      rowsData.value.sort((a: any, b: any) => a.priority - b.priority);
    },
    format: (data:any) => {
      if (data.priority == rowsData.value.length ){
        return ''
      }
      return '↓'
    },
    class: () => "cursor-pointer",
    styles: { td: { width: '20\px' } },
  },
  {
    label: translate("messages.multipleDepositConfig.action"),
    field: "",
    isFunction: true,
    function: async (data: any) => {
      console.log(rowsData.value)
      console.log(data)
      if (confirm(`Are you sure you want to delete this config? ( ${data.paymentName} )`)) {
        let newData = rowsData.value.filter(item => item.id !== data.id);

        newData = newData.map((item, index) => ({
          ...item,
          priority: item.priority - (index >= rowsData.value.findIndex(item => item.id === data.id) ? 1 : 0)
        }));
        rowsData.value = newData
      }
    },
    format: () => translate("messages.tierConfig.deleteTierConfig"),
    class: () => "text-white bg-red-400 cursor-pointer",
    permission: "PAYMENT_CONFIG.MULTIPLE.DEPOSIT",
    styles: { td: { width: '120\px' } },
  },

]);

onMounted(async () => {
  await getAllowPayment();
  await fetchPayment();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.multipleDepositConfig.name')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateMultipleDepositDialog.value = true)),
            class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-white mr-2",
              icon: ['fas', 'plus'],
              transform: ""
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.multipleDepositConfig.create")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.paymentConfig.deposit")), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("messages.paymentConfig.close")), 1),
            _createVNode(_unref(Switch), {
              "model-value": disableDeposit.value,
              "onUpdate:modelValue": onToggleDeposit,
              class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", disableDeposit.value ? 'bg-green-500' : 'bg-red-500'])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass([disableDeposit.value ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
                }, null, 2)
              ]),
              _: 1
            }, 8, ["model-value", "class"]),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("messages.paymentConfig.open")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(DataTable, {
        data: rowsData.value,
        columns: columns.value,
        isLoaded: isLoaded.value
      }, null, 8, ["data", "columns", "isLoaded"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (updatePayment())),
        class: "md:ml-3 inline-flex items-center px-6 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
      }, _toDisplayString(_ctx.$t("messages.multipleDepositConfig.save")), 1)
    ]),
    (_unref(useDepositFalse).length)
      ? (_openBlock(), _createBlock(MultipleDepositTierConfig, {
          key: 0,
          show: showCreateMultipleDepositDialog.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showCreateMultipleDepositDialog).value = $event)),
          onUpdate: addPayment,
          data: _unref(useDepositFalse)
        }, null, 8, ["show", "data"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})